<template>
    <h2 class="lg:mt-4 lg:pt-5 max-lg:mt-[-40px] pb-4 text-2xl">
        <strong>{{ $t('timesheet.Zeiterfassung') }}</strong>
        <span v-if="screenWidth >= 1000"> - Management Tool</span>
    </h2>
    <div class="text-center">
        <div class="lg:w-1/4 w-1/2 inline-grid max-lg:mt-5">
            <h3 class="text-lg">
                <span v-if="screenWidth >= 1000">{{ $t('timesheet.Datum') }} =</span>
                {{ greyAreaValues.date }}
            </h3>
            <br />
            <div>
                <span v-if="screenWidth >= 1000">{{ $t('timesheet.Anderes_Datum') }}:</span>
                <input
                    type="date"
                    class="lg:w-[35%] w-[75%] ml-[10px] shadow"
                    @click="greyAreaValues.customDate;"
                />
            </div>
        </div>
        <div class="lg:w-1/4 w-1/2 inline-grid">
            <h3 class="text-lg">
                <span v-if="screenWidth >= 1000">{{ $t('timesheet.Zeit') }} = </span
                >{{ computedTime }}
            </h3>
            <br />
            <div>
                <span v-if="screenWidth >= 1000">{{ $t('timesheet.Zeiteingabe') }}:</span>
                <input type="time" class="lg:w-[25%] w-[75%] ml-[10px] shadow" />
            </div>
        </div>
        <div class="lg:w-1/4 w-full max-lg:mt-5 inline-grid">
            <h3 class="text-lg my-4">
                <span class="whitespace-nowrap overflow-hidden pr-[10px] font-medium">
                    Start: {{ greyAreaValues.start }}</span
                >
                <span class="whitespace-nowrap overflow-hidden pr-[10px] font-medium">
                    {{ $t('timesheet.Ende') }}: {{ greyAreaValues.end }}</span
                >
            </h3>
            <button
                class="text-center font-medium align-middle leading-10 cursor-pointer rounded shadow bg-[#db0720] text-white hover:bg-[#ce0720] max-lg:mt-3"
                @click="toggleCheckinButton = false"
                v-if="toggleCheckinButton"
            >
                Checkin
            </button>
            <button
                class="text-center font-medium align-middle leading-10 cursor-pointer rounded shadow bg-[#db0720] text-white hover:bg-[#ce0720] max-lg:mt-3"
                @click="toggleCheckinButton = true"
                v-else
            >
                Checkout
            </button>
        </div>
        <div class="lg:w-1/4 w-full inline-grid align-super">
            <br />
            <router-link to="/monthlyreport">
                <button
                    class="text-center font-medium align-middle leading-8 cursor-pointer rounded shadow bg-[#FFF] text-black lg:w-[70%] w-full border-[1px] border-black hover:bg-[#F7F7F7] max-lg:mt-3"
                >
                    {{ $t('timesheet.Monatsrapport1') }}
                    <div class="whitespace-nowrap overflow-hidden">
                        {{ $t('timesheet.Monatsrapport2') }}
                    </div>
                </button>
            </router-link>
        </div>
        <div class="mt-5 pt-2 text-left text-lg">
            <h3 v-if="screenWidth >= 1000">
                {{ $t('timesheet.timesheetAdvice') }}
            </h3>
        </div>
    </div>
</template>

<script lang="js">
    import { defineComponent } from 'vue'
    import sourceData from '@/components/MockJSONFiles (temp)/MockJSONTimesheetFile.json' // MOCK JSON file
    import { useI18n } from 'vue-i18n'

    export default defineComponent({
        data() {
            return {
                screenWidth: window.innerWidth,
                toggleCheckinButton: true,

                greyAreaValues: {
                    date: '',
                    time: '',
                    customDate: '',
                    customTime: '',
                    start: '--:--:--',
                    end: '--:--:--',
                    workTimeAlready: [0, 0],
                },

                whiteAreaValues: {
                    workTime: '--:--',
                    workLoad: 0,
                },

                timesheetInstances: sourceData.timesheetInstances, // {jobId; start; end; length; task; description}
                tasktableInstances: sourceData.tasks, // {jobId; task; status; taskedDate}
            }
        },

        computed: {
            computedTime() {
                setInterval(() => {
                    this.greyAreaValues.time = this.setTimers()
                }, 1000)
                return this.setTimers()
            },
        },
        mounted() {
            let today = new Date()
            this.getTime(today)
            window.addEventListener('resize', this.getDimensions)
        },

        updated() {
            let today = new Date()
            this.getTime(today)
        },

        methods: {
            getDimensions() {
                this.screenWidth = document.documentElement.clientWidth
            },

            getTime(timeValue) {
                this.greyAreaValues.date = timeValue.toLocaleString('de-CH', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                })
                this.greyAreaValues.time = timeValue.toLocaleString('de-CH', {
                    hour: '2-digit',
                    minute: '2-digit',
                })
            },

            setTimers() {
                let today = new Date()
                let runningTime = today.toLocaleString('de-CH', {
                    hour: '2-digit',
                    minute: '2-digit',
                })
                return runningTime
            },
        },
    })
</script>
